import type { Intersection2d, Point2d, SimpleMesh2d } from ".."
import { divideMesh } from "./divideMesh"
import { meshToFaces } from "./meshToFaces"
import type { NameVirtualNode } from "./nameVirtualNode"
import { nameVirtualNode } from "./nameVirtualNode"
import { polygonToMesh } from "./polygonToMesh"
import type { Face2dComputed } from "../../mesh"
import type { Identified } from "../../utils"

export type DivideInsetFaceOptions = {
  tangledInsetFace: Face2dComputed
  makeNodeId?: NameVirtualNode
}

export type DivideInsetFaceProcedure = {
  dividedMeshNodeGroups: (Identified & Point2d)[][]
  meshIntersections: Intersection2d[]
}

export const divideInsetFace = ({
  tangledInsetFace,
  makeNodeId = nameVirtualNode,
}: DivideInsetFaceOptions): {
  result: (Face2dComputed & Identified)[]
  procedure: DivideInsetFaceProcedure
} => {
  const mesh = polygonToMesh(tangledInsetFace, makeNodeId)
  const {
    result: dividedMesh,
    procedure: { intersections: meshIntersections },
  } = divideMesh(mesh, makeNodeId)
  const faces = meshToFaces(dividedMesh)
  const dividedMeshNodeGroups: (Identified & Point2d)[][] = [
    Object.entries(dividedMesh.nodes).map(([id, node]) => ({
      ...node,
      id,
    })),
  ]

  return {
    result: faces,
    procedure: { dividedMeshNodeGroups, meshIntersections },
  }
}
